import { useAtomValue } from 'jotai';

import { TableSkeleton } from '@/lib/components';
import { Flex } from '@/lib/v2/components';

import { ActionsTable } from '@/src/modules/CampaignsModule/components/CampaignActions/ActionsTable';

import { ActionBarButtons } from './components/ActionBarButtons';
import { FilterBar } from './components/FilterBar';

import {
  atomActionsList,
  atomTotalSelectedRows,
  atomTotalsProcess,
} from '@/modules/CampaignsModule/atoms/campaignAtom';

export const TableContainer = () => {
  const actionsList = useAtomValue(atomActionsList);
  const totalSelectedRows = useAtomValue(atomTotalSelectedRows);
  const totalsCampaignList = useAtomValue(atomTotalsProcess);

  return (
    <Flex column>
      {actionsList ? (
        <>
          <Flex alignment="start" className="mb-[16px]">
            {totalSelectedRows > 0 ? (
              <ActionBarButtons />
            ) : (
              <>{totalsCampaignList.total > 0 && <FilterBar />}</>
            )}
          </Flex>
          <Flex column withGap itemAlignment="stretch">
            <ActionsTable />
          </Flex>
        </>
      ) : (
        <div className="h-full w-full py-10">
          <TableSkeleton columns={6} />
        </div>
      )}
    </Flex>
  );
};
